var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0438 6.94378C14.8 6.70003 14.4063 6.69378 14.1625 6.93753C13.9188 7.18128 13.9125 7.57503 14.1563 7.81878C14.725 8.39378 15.0375 9.15628 15.0375 9.96878C15.0375 10.7813 14.7063 11.5875 14.1063 12.1688C13.8563 12.4063 13.85 12.8063 14.0938 13.05C14.2188 13.175 14.3813 13.2375 14.5438 13.2375C14.7063 13.2375 14.8563 13.1813 14.9813 13.0625C15.825 12.2438 16.2938 11.1438 16.2938 9.96878C16.2938 8.79378 15.8563 7.75628 15.0563 6.94378H15.0438Z",
    fill: "#BFBFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 5.175C17.1562 4.93125 16.7625 4.93125 16.5125 5.175C16.2687 5.41875 16.2687 5.8125 16.5125 6.05625C17.5562 7.10625 18.125 8.49375 18.125 9.96875C18.125 11.4437 17.5312 12.8875 16.4562 13.9375C16.2125 14.1812 16.2062 14.575 16.45 14.8187C16.575 14.9437 16.7375 15.0063 16.8937 15.0063C17.05 15.0063 17.2062 14.9437 17.3312 14.825C18.65 13.5312 19.375 11.8063 19.375 9.9625C19.375 8.11875 18.675 6.45 17.4 5.16875V5.175Z",
    fill: "#BFBFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 6.26245C3.7 6.26245 3.675 6.26245 3.6625 6.26245H1.90625C1.2 6.26245 0.625 6.83745 0.625 7.5437V12.475C0.625 13.1812 1.2 13.7562 1.90625 13.7562H3.6625C3.6625 13.7562 3.6875 13.7562 3.7 13.7562V6.27495V6.26245Z",
    fill: "#BFBFBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.475 2.34368C10.9875 2.08118 10.4 2.10618 9.9312 2.41243L4.94995 5.70618V14.2874L9.9312 17.5812C10.1812 17.7499 10.475 17.8312 10.7625 17.8312C11.0062 17.8312 11.25 17.7687 11.475 17.6499C11.9625 17.3874 12.2625 16.8812 12.2625 16.3249V3.66868C12.2625 3.11243 11.9625 2.60618 11.475 2.34368Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.0647ee12a04e29e5f09cab0f7c4a68d3.svg";
export { ForwardRef as ReactComponent };